import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ReplenishmentPutawayPageRBAC = {
  pageID: 'de445b2b65dfcee980b980194c82ff75',
  elementID: {
    ViewPage: '8e38c8389eca35e5a013eee53c2f05a7',
    ViewDetailReplenish: '9461b1b8389642dc143de63b3f233892',
  },
} as const

export const useRBACReplenishmentPutawayPage = createUseRBAC(ReplenishmentPutawayPageRBAC.elementID)

export type UseRBACReplenishmentPutawayPageType = ReturnType<typeof useRBACReplenishmentPutawayPage>
